import { cn } from "@/modules/lib/utils"
import { TrainingAdsSection } from "@/modules/training/components/trainingAdsSection"
import { TrainingDateSelector } from "@modules/training/components/trainingDateSelector"
import { TrainingInformation } from "@modules/training/components/trainingInformation"

type TrainingHeaderProps = {
  className?: string
} & React.ComponentProps<"div">

export function TrainingHeader({ className, ...props }: TrainingHeaderProps) {
  return (
    <div className={cn("flex max-h-52 min-h-52 w-full justify-between gap-1 lg:gap-2 xl:gap-3", className)} {...props}>
      <TrainingDateSelector className="w-[20%]" />
      <TrainingInformation className="flex min-w-[55%] grow" />
      <TrainingAdsSection className="w-[25%]" />
    </div>
  )
}
